export default __webpack_public_path__ + "afbed0ca19864016cd924423a0ef4aa6.woff2";